module.exports = __webpack_public_path__ + "img/logoacasia.8b5d829c.svg";